type BibleColorThemesType = {
    default: 'default',
    darkMode: 'darkMode',
}
export const BibleColorThemes: BibleColorThemesType = {
    default: 'default',
    darkMode: 'darkMode',
}

export type BibleColorThemesValues = typeof BibleColorThemes[keyof typeof BibleColorThemes]

export const AllBibleColorThemes: BibleColorThemesValues[] = Array.from(Object.values(BibleColorThemes));

export default BibleColorThemes;